import { observer } from 'mobx-react-lite';
import { Tooltip } from '@mui/material';

import { TopicUser } from '@/dmdrive/topic/entities/TopicUser';

import { ViewerRolesAvatar, ViewerRolesRoot } from './UserRoles.styles';

interface UserRolesProps {
  user: Nullable<TopicUser>;
}

function UserRoles(props: UserRolesProps) {
  const { user } = props;

  if (!user) {
    return null;
  }

  return (
    <ViewerRolesRoot>
      {user.isOwner && (
        <Tooltip title="Owner">
          <ViewerRolesAvatar>O</ViewerRolesAvatar>
        </Tooltip>
      )}

      <Tooltip title={user.isMaster ? 'Master' : 'Spectator'}>
        <ViewerRolesAvatar>{user.isMaster ? 'M' : 'S'}</ViewerRolesAvatar>
      </Tooltip>
    </ViewerRolesRoot>
  );
}

export default observer(UserRoles);
